import { type MutationHookOptions, useMutation } from "@apollo/client";
import { ConnectPayPalMutation } from "../graphql/mutations";
import type {
  ConnectPayPalMutationType,
  ConnectPayPalMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useConnectPayPalMutation = (
  options?: MutationHookOptions<
    ConnectPayPalMutationType,
    ConnectPayPalMutationVariablesType
  >
) => {
  return useMutation<
    ConnectPayPalMutationType,
    ConnectPayPalMutationVariablesType
  >(ConnectPayPalMutation, options);
};
